const API_BASE = process.env.REACT_APP_API_URL || "/api";

function resolveDownloadUrl(path: string) {
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  if (path.startsWith("/")) {
    return `${API_BASE}${path.startsWith("/api/") ? path.slice(4) : path}`;
  }
  return `${API_BASE}/${path}`;
}

function getFilename(disposition: string | null, fallback = "download.xlsx") {
  if (!disposition) return fallback;
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }
  const basicMatch = disposition.match(/filename="?([^"]+)"?/i);
  return basicMatch?.[1] || fallback;
}

/**
 * Download a file through fetch so development proxy routing and auth cookies
 * behave the same way as the rest of the API client.
 */
export async function triggerDownload(path: string) {
  const response = await fetch(resolveDownloadUrl(path), {
    credentials: "include",
    headers: {
      Accept: "*/*",
    },
  });

  if (!response.ok) {
    let message = "Download failed";
    try {
      const body = await response.json();
      message = body.detail || body.message || message;
    } catch {
      // Ignore non-JSON error bodies and keep the generic message.
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const filename = getFilename(response.headers.get("Content-Disposition"));
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}
